<template>
  <div class="pane">
    <!-- 标题 下载验收单模板（乙方）-->
    <div class="title-box">
      <h2 class="title">下载验收单模板（乙方）</h2>
      <el-popover popper-class="gray-popper" placement="right-end" width="260" trigger="hover">
        <div class="text">主要提供给外包供应商下载结算单和验收单模板</div>
        <svg-icon class="icon" icon-class="explain" slot="reference" />
      </el-popover>
    </div>

    <div class="model-box">
      <div class="list">
        <div class="value-box">
          <a :href="`${publicPath}结算对账单（样式）.xlsx`" class="download">英雄游戏结算单 <i class="el-icon-arrow-right"></i></a>

        </div>
        <div class="value-box">
          <a :href="`${publicPath}设计制作验收单（样式）.xlsx`" class="download">英雄游戏验收单 <i class="el-icon-arrow-right"></i></a>
        </div>
      </div>
    </div>

    <!-- 分隔线 -->
    <div class="line"></div>

    <!-- 标题 上传验收单（乙方）-->
    <div class="title-box">
      <h2 class="title">上传验收单（乙方）</h2>
    </div>
    <el-form ref="uploadForm" :rules="uploadRules" :model="uploadForm">

      <div class="model-box">
        <div class="item-box all">
          <div class="label"><span style="color: #ff4949;margin-right: 4px;">*</span>上传结算单（需乙方盖章）</div>

          <el-form-item prop="settlementFileId">
            <div class="file-list" v-if="dataSource.status === 5" style="height:20px">
              <svg-icon :icon-class="settlementFile.suffixType === 'pdf'?'pdf-icon':'jpg-icon'" class="icon" />
              <span class="title" @click="previewFun(settlementFile)" style="cursor:pointer">{{settlementFile.fileName}}</span>
              <span style="color:#999">({{fileSize}})</span>
              <el-button type="text" style="color:#3a89ff;padding:0 10px;line-height:20px" @click="downloadUrlFun(settlementFile.id)">下载</el-button>
            </div>
            <div v-else-if="accessPoint['mineuser']">
              <!-- <div v-else > -->
              待乙方上传
            </div>
            <simple-uploader ref="exampleUploader" source="coop" :isSource="fileChunkUploadUrl" @onSuccess="handleSuccess(arguments,'settlementFileId')" @onRemove="handleRemove(arguments,'settlementFileId')" :maxNum='1'
              v-else-if="accessPoint['outuser']" :disabled="dataSource.status !== 4"></simple-uploader>

          </el-form-item>

          <!-- 待乙方上传 -->
        </div>

        <div class="item-box all">
          <div class="label"><span style="color: #ff4949;margin-right: 4px;">*</span>上传验收单（需乙方盖章、甲方签字）</div>
          <el-form-item prop="acceptanceFileId">
            <div class="file-list" v-if="dataSource.status === 5" style="height:20px">
              <svg-icon :icon-class="acceptanceFile.suffixType === 'pdf'?'pdf-icon':'jpg-icon'" class="icon" />
              <span class="title" @click="previewFun(acceptanceFile)" style="cursor:pointer">{{acceptanceFile.fileName}}</span>
              <span style="color:#999">({{fileSize}})</span>
              <el-button type="text" style="color:#3a89ff;padding:0 10px;line-height:20px" @click="downloadUrlFun(acceptanceFile.id)">下载</el-button>

            </div>
            <div v-else-if="accessPoint['mineuser']">
              待乙方上传
            </div>

            <simple-uploader ref="exampleUploader" source="coop" :isSource="fileChunkUploadUrl" @onSuccess="handleSuccess(arguments,'acceptanceFileId')" @onRemove="handleRemove(arguments,'acceptanceFileId')" :maxNum='1'
              v-else-if="accessPoint['outuser']" :disabled="dataSource.status !== 4"></simple-uploader>

          </el-form-item>

          <!-- 待乙方上传 -->

        </div>
      </div>
    </el-form>
    <!-- 图片预览 -->
    <image-viewer v-if="showViewer" :show-viewer="showViewer" :on-close="closeViewer" :url-list="[bugUrl]" :list-data="detailsData" @download="downloadUrlFun(detailsData.id)"></image-viewer>

  </div>
</template>

<script>
import SimpleUploader from '../../../materialCenter/components/simpleUploader.vue'
import { outsource_saveAcceptanceFile } from '@File~/api/outsourcing'

import ImageViewer from '../ImageViewer'
import { byteToStr, fileType } from '@/utils'
import { apiUrl } from '@File~/api/env'


export default {
  components: { SimpleUploader, ImageViewer },
  inject: ['reload'],
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return null
      }
    }
  },
  data() {
    return {
      fileChunkUploadUrl: this.$store.getters.uploadUrl,//apiUrl.fileUrl + "/api/file/fileChunkUpload",
      //图片所需参数
      detailsData: [],
      bugUrl: '',
      showViewer: false,

      accessPoint: this.$store.getters.accessPoint, //权限点
      uploadForm: {
        settlementFileId: '',
        acceptanceFileId: '',
      },
      uploadRules: {
        settlementFileId: [{ required: true, message: '请上传结算单文件', trigger: 'required' }],
        acceptanceFileId: [{ required: true, message: '请上传验收单文件', trigger: 'required' }],
      },
      publicPath: process.env.BASE_URL,
      settlementFile: {},
      fileSize: '',
      acceptanceFile: {}
    }
  },
  created() {
    this.settlementFile = this.dataSource.settlementFileDetail ? JSON.parse(this.dataSource.settlementFileDetail) : []
    this.fileSize = this.dataSource.settlementFileDetail ? byteToStr(JSON.parse(this.dataSource.settlementFileDetail).fileSize) : 0
    this.acceptanceFile = this.dataSource.acceptanceFileDetail ? JSON.parse(this.dataSource.acceptanceFileDetail) : []
  },
  methods: {
    isFileType(type) {
      return fileType(type);
    },
    // 关闭图片预览
    closeViewer() {
      // console.log('关闭预览===')
      this.showViewer = false
      this.bugUrl = ''
      this.listData = {}
    },
    previewFun(data) {
      if (this.isFileType(data.suffixType) === 'picture' && data.loadFileBinaryUrl) { // 图片 显示大图
        this.bugUrl = data.loadFileBinaryUrl
      } else {// 视频、其它
        this.bugUrl = data.thumbnailImageUrl
      }
      this.detailsData = data
      this.showViewer = true;
    },

    downloadUrlFun(id) {
      var form = document.createElement('form')
      document.body.appendChild(form)
      form.setAttribute('style', 'display:none');
      form.setAttribute('method', 'post');
      form.setAttribute('action', this.$store.getters.downloadUrl);//下载文件的请求路径

      // 创建表单里 input 元素
      var tempInput = document.createElement("input");
      tempInput.type = "hidden";
      tempInput.name = 'fileId';
      tempInput.value = id;
      form.appendChild(tempInput);

      var tempInput2 = document.createElement("input");
      tempInput2.type = "hidden";
      tempInput2.name = 'userId';
      tempInput2.value = this.$store.getters.userId;
      form.appendChild(tempInput2);

      form.submit()
      document.body.removeChild(form)
    },
    // 上传成功
    handleSuccess(arr, tag) {
      this.uploadForm[tag] = arr[0];
      this.$nextTick(() => {
        this.$refs.uploadForm.validateField(tag)
      })
    },

    // 删除已上传
    handleRemove(fileList, tag) {
      this.uploadForm[tag] = fileList[0] ? fileList[0] : '';

    },
    sureFun(noticeType) {
      this.$refs.uploadForm.validate((valid) => {
        if (valid) {
          //    console.log('通过');
          let data = {
            id: this.dataSource.id,
            userId: this.$store.state.user.userId,
            status: 5,
            settlementFileId: this.uploadForm.settlementFileId,
            acceptanceFileId: this.uploadForm.acceptanceFileId,
            noticeType: noticeType,
          }
          outsource_saveAcceptanceFile(data).then(response => {
            if (response.code == 1) {
              this.$message({ type: 'success', message: '操作成功' })
              this.reload()
            }
          })
        }
      })

    }
  }
}
</script>

<style lang="scss" scoped>
.model-box {
  .label {
    min-width: 258px !important;
  }
}
.thumbnailImageClass {
  width: 25px;
  height: 25px;
  background-color: white;
  background-size: contain;
  background-repeat: no-repeat;
}
.file-list {
  display: flex;
  justify-content: center;
  align-items: center;
}

.model-box ::v-deep .el-form-item__content {
  line-height: 20px;
}
</style>